import React from "react";
import { useNode } from "@craftjs/core";
import styled from "@emotion/styled";
import { NoBlock } from "@uiComponents/shared/NoBlock";
import { Resizer } from "../../shared/Resizer";

const ColumnStyled = styled.div<IColumnProps>`
  display: flex;
  flex-direction: column;
  -webkit-box-align: stretch;
  align-items: stretch;
  line-height: normal;
  width: ${(props) => `calc(${props.width} - 10px)`};
  margin-left: 20px;
  :first-of-type {
    margin-left: 0;
  }

  &.component-selected {
    ::after {
      border: solid 1px black;
    }
  }
`;

export interface IColumnProps {
  width?: string;
  height?: string;
  children: React.ReactNode;
}

const defaultProps = {
  width: "50%",
  height: "auto",
};

export const Column = (props: Partial<IColumnProps>) => {
  props = {
    ...defaultProps,
    ...props,
  };

  const { width, children } = props;
  const {
    connectors: { connect },
  } = useNode();

  return (
    <>
      <ColumnStyled ref={connect as any} width={width}>
        <Resizer
          propKey={{ width: "width", height: "height" }}
          resizeHandles={["left", "right"]}
          hasParent={true}
        >
          {!children && <NoBlock />}
          {children}
        </Resizer>
      </ColumnStyled>
    </>
  );
};

Column.craft = {
  props: defaultProps,
};
